import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { PropTypes } from 'prop-types';
import withLoader from 'components/organisms/withLoader';
import PgrogressBar from './components/progressBar';
import QuestionsList from './components/questionsList';
import ControlBtns from './components/controlBtns';

const getCompletedSteps = (groups) => {
  const completedSteps = [];
  groups.forEach(({ questions }, step) => {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].patientAnswer) {
        completedSteps.push(step);
      }
    }
  });
  return completedSteps;
};

const Questionnaire = ({ patientGuid, canEditPage }) => {
  const [step, setStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);

  const {
    ccmPatientDetails: { getQuestions, putQuestions },
  } = useDispatch();

  useEffect(() => {
    getQuestions(patientGuid);
  }, [patientGuid]);

  const {
    getQuestions: questionsLoading,
    putQuestions: sendingAnswersToBackend,
  } = useSelector((state) => state.loading.effects.ccmPatientDetails);

  const {
    questions: { groups },
    answers,
  } = useSelector((state) => state.ccmPatientDetails);

  useEffect(() => {
    if (groups) setCompletedSteps(getCompletedSteps(groups));
  }, [groups]);

  const backBtnHandler = () => {
    if (step === 0) return;
    setStep(step - 1);
  };

  const forwardBtnHandler = () => {
    if (step === groups.length) return;
    setStep(step + 1);
  };

  const saveBtnHandler = async () => {
    const { success } = await putQuestions({
      patientGuid,
      answers: answers[step],
    });

    if (!completedSteps.includes(step) && success)
      setCompletedSteps([...completedSteps, step]);
  };

  return (
    <div className="questionnaire">
      {withLoader(
        questionsLoading,
        <>
          {groups && (
            <>
              <Row>
                <Col xl="1" lg="1" md="2" xs="3">
                  <PgrogressBar
                    completedSteps={completedSteps}
                    currentStep={step}
                    totalSteps={groups.length}
                    clickHandler={(i) => setStep(i)}
                    canEditPage={canEditPage}
                  />
                </Col>
                <Col
                  xl="11"
                  lg="11"
                  md="10"
                  xs="9"
                  className="questionnaire__main"
                >
                  <QuestionsList
                    group={groups[step]}
                    current={step}
                    canEditPage={canEditPage}
                  />
                </Col>
              </Row>
              <ControlBtns
                currentStep={step}
                totalSteps={groups.length - 1}
                backBtnHandler={backBtnHandler}
                saveBtnHandler={saveBtnHandler}
                saveBtnDisable={questionsLoading || sendingAnswersToBackend}
                forwardBtnHandler={forwardBtnHandler}
              />
            </>
          )}
        </>,
      )}
    </div>
  );
};

Questionnaire.propTypes = {
  patientGuid: PropTypes.string.isRequired,
  canEditPage: PropTypes.bool,
};

export default Questionnaire;
